// Rodapé dos modais de gestão da assinatura. Mesmo visual do rodapé padrão
// do AerosDialog, mas com alvos de 44px e botões em largura total no celular
// (o padrão tem ~34px de altura). `danger` pinta a ação destrutiva.
import React from "react";
import { makeStyles, alpha } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";

import useAerosModalStyles from "../../styles/aerosModalStyles";
import { AEROS, stateText } from "../../styles/aerosTokens";

const useStyles = makeStyles((theme) => ({
  actions: {
    marginLeft: "auto",
    display: "flex",
    gap: 10,
    flexWrap: "wrap",
    justifyContent: "flex-end",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      flexDirection: "column-reverse",
      "& > *": { width: "100%" },
    },
  },
  button: { minHeight: 44, touchAction: "manipulation" },
  danger: {
    backgroundColor: alpha(AEROS.error, 0.12),
    border: `1px solid ${alpha(AEROS.error, 0.45)}`,
    color: stateText(theme, AEROS.error, "error"),
    boxShadow: "none",
    "&:hover": { backgroundColor: alpha(AEROS.error, 0.2), boxShadow: "none" },
  },
}));

const ManageFooter = ({
  cancelLabel,
  onCancel,
  submitLabel,
  onSubmit,
  submitDisabled = false,
  loading = false,
  danger = false,
}) => {
  const m = useAerosModalStyles();
  const classes = useStyles();
  return (
    <div className={m.footer}>
      <div className={classes.actions}>
        <Button
          className={`${m.cancelButton} ${classes.button}`}
          onClick={onCancel}
          disabled={loading}
        >
          {cancelLabel}
        </Button>
        {onSubmit && (
          <Button
            variant={danger ? "outlined" : "contained"}
            color={danger ? "default" : "primary"}
            className={`${m.submitButton} ${classes.button} ${danger ? classes.danger : ""}`}
            onClick={onSubmit}
            disabled={submitDisabled || loading}
            aria-busy={loading}
          >
            {submitLabel}
            {loading && <CircularProgress size={24} className={m.buttonProgress} />}
          </Button>
        )}
      </div>
    </div>
  );
};

export default ManageFooter;
